import { render, staticRenderFns } from "./BeatProgress.vue?vue&type=template&id=49ffbad4&scoped=true&"
import script from "./BeatProgress.vue?vue&type=script&lang=js&"
export * from "./BeatProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffbad4",
  null
  
)

export default component.exports